import { useState, useEffect, useCallback } from "react";
import { apiGet, apiDelete } from "@/config";
import ComposeEmail from "@/components/ComposeEmail";
import { SubscribersList, SubscribersToolbar } from "@/components/SubscribersParts";

const SubscribersPanel = ({ isOpen, onClose }) => {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState("list");

  const fetchSubscribers = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await apiGet("/subscribers");
      setSubscribers(data);
    } catch {
      setSubscribers([]);
    } finally {
      setLoading(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isOpen) {
      fetchSubscribers();
      setView("list");
    }
  }, [isOpen, fetchSubscribers]);

  const handleRemove = async (email) => {
    if (!window.confirm(`Remove ${email}?`)) return;
    try {
      await apiDelete(`/subscribers/${encodeURIComponent(email)}`);
      setSubscribers((prev) => prev.filter((s) => s.email !== email));
    } catch {
      alert("Failed to remove subscriber");
    }
  };

  const handleCopyAll = () => {
    navigator.clipboard.writeText(subscribers.map((s) => s.email).join(", "));
    alert(`${subscribers.length} email(s) copied to clipboard`);
  };

  if (!isOpen) return null;

  return (
    <div data-testid="subscribers-panel" className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4">
      <div className="bg-slate-900 border border-slate-700 rounded-xl max-w-lg w-full max-h-[80vh] flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-slate-800">
          <h3 className="text-lg font-bold text-white">Subscribers ({subscribers.length})</h3>
          <SubscribersToolbar view={view} subscriberCount={subscribers.length} onEmailAll={() => setView("compose")} onCopyAll={handleCopyAll} onClose={onClose} />
        </div>
        <div className="flex-1 overflow-y-auto">
          {view === "compose" ? (
            <ComposeEmail subscriberCount={subscribers.length} onBack={() => setView("list")} />
          ) : (
            <SubscribersList subscribers={subscribers} loading={loading} onRemove={handleRemove} />
          )}
        </div>
      </div>
    </div>
  );
};

export default SubscribersPanel;
